import * as React from 'react';
import { useQuery } from '@tanstack/react-query';
import { useListScheduledReports } from 'hooks/api/reports';
import { ScheduledStockBalanceReport } from 'contracts/scheduledRepports';
import { DataTable } from 'components/ui/DataTable';
import { getColumns } from './columns';

const columns = getColumns();

export const PendingStocks = () => {
  const { listReports } =
    useListScheduledReports<ScheduledStockBalanceReport>();

  const scheduledReportsQuery =
    useQuery({
      queryKey: ['listReports'],
      queryFn: () =>
        listReports({
          type: 'pending-stocks',
        }),
      initialData: [],
    });

  return (
    <section className="w-full h-auto">
      <DataTable
        data={scheduledReportsQuery?.data ?? []}
        columns={columns}
        showControlColumns={false}
        isLoading={scheduledReportsQuery.isLoading}
      />
    </section>
  );
};
